/**
 * App Config File
 */
export const baseImgPath = process.env.NODE_ENV === 'production' ? '/admin' : ''
export default {
    baseImgUrl: baseImgPath,
    appLogo: baseImgPath + '/static/img/logo-tat.png', // App Logo,
    darkLogo: baseImgPath + '/static/img/logo-tat.png', // dark logo
    appLogo2: baseImgPath + '/static/img/logo-tat.png', // App Logo 2 For Login & Signup Page
    brand: 'TAT-Dashboard', // Brand Name
    copyrightText: 'TAT-Dashboard © 2018 All Rights Reserved.', // Copyright Text
    text_notice: `”ข้อมูลจำนวนคนเดินทางเข้าประเทศไทยรายวัน ตั้งแต่วันที่ 21 กันยายน 2562 ถึงปัจจุบัน อยู่ระหว่างการตรวจสอบ”`,
    enableUserTour: process.env.NODE_ENV === 'production' ? true : false, // Enable User Tour
}
